import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";

import { styled } from "@mui/material/styles";

export const Scrollbar = styled(SimpleBar)``;
